function start_chat(){
	triggerConsoltoAction('start-chat','AVAILABLE')
	setTimeout(() => {
		document.getElementById('expertips_iframe').style.display = 'block'
	}, "100");
}

function start_call(){
	triggerConsoltoAction('start-call','AVAILABLE')
	setTimeout(() => {
		document.getElementById('expertips_iframe').style.display = 'block'
	}, "100");
}

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get("open_chat") === "true") {
	setTimeout(() => {
		start_chat();
	}, "100");
}

(() => {

	const ATTR_LABEL = "Authority To Leave"; // cart attribute key

	async function setCartAttribute(label, value) {
		console.log('setting:',value)
		const res = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			credentials: 'same-origin',
			body: JSON.stringify({
				attributes: { [label]: value }
			})
		});
		if (!res.ok) {
			const text = await res.text().catch(() => '');
			throw new Error(`Cart update failed (${res.status}): ${text}`);
		} else {
			console.log('update sucsess:',res)
		}
		return res.json(); // updated cart object
	}

	// Event delegation so it works even if the drawer content is replaced
	document.addEventListener('change', async (e) => {
		const input = e.target;
		if (!input.matches('.cart-authority input[type="radio"]')) return;
		if (!input.checked) return;

		console.log('changed');

		const value = input.value; // e.g. "Yes" / "No"
		try {
			await setCartAttribute(ATTR_LABEL, value);
			console.log('Saved cart attribute:', ATTR_LABEL, '→', value);
		} catch (err) {
			console.error(err);
		}
	});
	console.log('authority:',authority)
	if (authority == '') {
		setTimeout(function () {
			console.log('set attribute')
			//needs a delay for this to work for some reason
			setCartAttribute(ATTR_LABEL, "Yes");
		}, 2000);
	}
})();